module.exports = __webpack_public_path__ + "img/83.8924617a.png";